import { useContext } from "react";
import { TipContext } from "../../containers/TipContext";
import styles from "./Item.module.css";
import Tippy from "@tippyjs/react";

const alt = {
  3001: "Abyssal Mask",
  3105: "Aegis of the Legion",
  3113: "Aether Wisp",
  1052: "Amplifying Tome",
  3003: "Archangel's Staff",
  3504: "Ardent Censer",
  1038: "B. F. Sword",
  6660: "Bami's Cinder",
  4642: "Bandleglass Mirror",
  3102: "Banshee's Veil",
  3006: "Berserker's Greaves",
  3071: "Black Cleaver",
  3864: "Black Mist Scythe",
  3153: "Blade of The Ruined King",
  1026: "Blasting Wand",
  4630: "Blighting Jewel",
  3072: "Bloodthirster",
  1001: "Boots",
  3009: "Boots of Swiftness",
  3076: "Bramble Vest",
  2424: "Broken Stopwatch",
  3860: "Bulwark of the Mountain",
  3133: "Caulfield's Warhammer",
  1031: "Chain Vest",
  6609: "Chempunk Chainsword",
  3011: "Chemtech Putrifier",
  1018: "Cloak of Agility",
  1029: "Cloth Armor",
  2419: "Commencing Stopwatch",
  2055: "Control Ward",
  2033: "Corrupting Potion",
  4629: "Cosmic Drive",
  3801: "Crystalline Bracer",
  1083: "Cull",
  1042: "Dagger",
  1082: "Dark Seal",
  3742: "Dead Man's Plate",
  6333: "Death's Dance",
  4637: "Demonic Embrace",
  6632: "Divine Sunderer",
  1055: "Doran's Blade",
  1056: "Doran's Ring",
  1054: "Doran's Shield",
  6691: "Duskblade of Draktharr",
  6692: "Eclipse",
  3814: "Edge of Night",
  2138: "Elixir of Iron",
  2139: "Elixir of Sorcery",
  2140: "Elixir of Wrath",
  1035: "Emberknife",
  3508: "Essence Reaver",
  6656: "Everfrost",
  3123: "Executioner's Calling",
  3513: "Eye of the Herald",
  1004: "Faerie Charm",
  3363: "Farsight Alteration",
  3108: "Fiendish Codex",
  3114: "Forbidden Idol",
  4401: "Force of Nature",
  3851: "Frostfang",
  6662: "Frostfire Gauntlet",
  3110: "Frozen Heart",
  6671: "Galeforce",
  3193: "Gargoyle Stoneplate",
  1011: "Giant's Belt",
  3024: "Glacial Buckler",
  6630: "Goredrinker",
  3026: "Guardian Angel",
  3177: "Guardian's Blade",
  3184: "Guardian's Hammer",
  2051: "Guardian's Horn",
  3112: "Guardian's Orb",
  3124: "Guinsoo's Rageblade",
  1039: "Hailblade",
  3863: "Harrowing Crescent",
  2003: "Health Potion",
  3051: "Hearthbound Axe",
  3155: "Hexdrinker",
  3145: "Hextech Alternator",
  3152: "Hextech Rocketbelt",
  4628: "Horizon Focus",
  6673: "Immortal Shieldbow",
  4005: "Imperial Mandate",
  3031: "Infinity Edge",
  3158: "Ionian Boots of Lucidity",
  6029: "Ironspike Whip",
  3600: "Kalista's Black Spear",
  3067: "Kindlegem",
  2015: "Kircheis Shard",
  3109: "Knight's Vow",
  6672: "Kraken Slayer",
  3035: "Last Whisper",
  4635: "Leeching Leer",
  6653: "Liandry's Anguish",
  3100: "Lich Bane",
  3190: "Locket of the Iron Solari",
  1036: "Long Sword",
  3036: "Lord Dominik's Regards",
  3802: "Lost Chapter",
  6655: "Luden's Tempest",
  3004: "Manamune",
  3156: "Maw of Malmortius",
  3041: "Mejai's Soulstealer",
  3139: "Mercurial Scimitar",
  3111: "Mercury's Treads",
  3222: "Mikael's Blessing",
  2403: "Minion Dematerializer",
  3117: "Mobility Boots",
  6617: "Moonstone Renewer",
  3165: "Morellonomicon",
  3033: "Mortal Reminder",
  3043: "Muramana",
  3115: "Nashor's Tooth",
  6675: "Navori Quickblades",
  1058: "Needlessly Large Rod",
  1057: "Negatron Cloak",
  4636: "Night Harvester",
  6670: "Noonquiver",
  1033: "Null-Magic Mantle",
  3916: "Oblivion Orb",
  1040: "Obsidian Edge",
  3364: "Oracle Lens",
  3857: "Pauldrons of Whiterock",
  2423: "Perfectly Timed Stopwatch",
  3044: "Phage",
  3046: "Phantom Dancer",
  1037: "Pickaxe",
  3047: "Plated Steelcaps",
  2052: "Poro-Snax",
  6693: "Prowler's Claw",
  3140: "Quicksilver Sash",
  3089: "Rabadon's Deathcap",
  6677: "Rageknife",
  3143: "Randuin's Omen",
  3094: "Rapid Firecannon",
  3074: "Ravenous Hydra",
  1043: "Recurve Bow",
  3107: "Redemption",
  2031: "Refillable Potion",
  1006: "Rejuvenation Bead",
  3858: "Relic Shield",
  4633: "Riftmaker",
  1028: "Ruby Crystal",
  3085: "Runaan's Hurricane",
  3855: "Runesteel Spaulders",
  3116: "Rylai's Crystal Scepter",
  3181: "Sanguine Blade",
  1027: "Sapphire Crystal",
  3330: "Scarecrow Effigy",
  3191: "Seeker's Armguard",
  3048: "Seraph's Embrace",
  6695: "Serpent's Fang",
  3134: "Serrated Dirk",
  6694: "Serylda's Grudge",
  3853: "Shard of True Ice",
  3057: "Sheen",
  2065: "Shurelya's Battlesong",
  6035: "Silvermere Dawn",
  2422: "Slightly Magical Footwear",
  3020: "Sorcerer's Shoes",
  3862: "Spectral Sickle",
  3211: "Spectre's Cowl",
  3850: "Spellthief's Edge",
  3065: "Spirit Visage",
  6616: "Staff of Flowing Water",
  3340: "Stealth Ward",
  3854: "Steel Shoulderguards",
  3053: "Sterak's Gage",
  4641: "Stirring Wardstone",
  2420: "Stopwatch",
  3095: "Stormrazor",
  6631: "Stridebreaker",
  3068: "Sunfire Aegis",
  3859: "Targon's Buckler",
  3070: "Tear of the Goddess",
  6676: "The Collector",
  4403: "The Golden Spatula",
  3075: "Thornmail",
  3077: "Tiamat",
  3748: "Titanic Hydra",
  2010: "Total Biscuit of Everlasting Will",
  3078: "Trinity Force",
  6664: "Turbo Chemtank",
  3179: "Umbral Glaive",
  1053: "Vampiric Scepter",
  4632: "Verdant Barrier",
  4643: "Vigilant Wardstone",
  3135: "Void Staff",
  3082: "Warden's Mail",
  3083: "Warmog's Armor",
  4638: "Watchful Wardstone",
  3066: "Winged Moonplate",
  3091: "Wit's End",
  3142: "Youmuu's Ghostblade",
  3400: "Your Cut",
  3086: "Zeal",
  3050: "Zeke's Convergence",
  3157: "Zhonya's Hourglass",
};

const Item = ({ id, type }) => {
  const tips = useContext(TipContext);
  const tip =
    tips.item && tips.item[id] ? (
      <div dangerouslySetInnerHTML={{ __html: tips.item[id] }} />
    ) : (
      <div className={styles.loading}>Loading...</div>
    );
  return (
    <>
      <Tippy
        content={tip}
        onShow={() => {
          if (!tips.showItem) tips.setShowItem(true);
        }}
        maxWidth={620}
      >
        <img
          className={styles[type]}
          src={`https://cdn5.xdx.gg/item24/${id}.webp`}
          srcSet={`https://cdn5.xdx.gg/item24/${id}.webp 24w,
                   https://cdn5.xdx.gg/item48/${id}.webp 48w`}
          width={24}
          height={24}
          alt={alt[id]}
        />
      </Tippy>
    </>
  );
};

export default Item;
